import React, { FocusEvent, RefObject } from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import tw from 'twin.macro';
import { inputRootStyle } from '@teetsh/app/src/components/Form/Input2';
import { css } from '@emotion/react';

export type Size = '3xl' | '2xl' | 'xl' | 'lg' | 'md' | 'sm';

export interface Props extends React.ComponentProps<typeof TextareaAutosize> {
  value: string;
  inputRef?: RefObject<HTMLTextAreaElement>;
  onConfirm?: (v: string) => void;
  placeholder?: string;
  testId?: string;
  minRows?: number;
  'aria-label'?: string;
  className?: string;
  size?: Size;
  removeHandle?: boolean;
  minimal?: boolean;
  onBlur?: (e: FocusEvent<HTMLTextAreaElement>) => void;
  onClick?: () => void;
  autoFocus?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  withCount?: boolean;
  maxLength?: number;
}

export const textSize = {
  '3xl': tw`text-3xl`,
  '2xl': tw`text-2xl`,
  xl: tw`text-xl`,
  lg: tw`text-lg`,
  md: tw``,
  sm: tw`text-sm`,
};

export default function Textarea(props: Props) {
  const {
    placeholder,
    className,
    inputRef,
    testId,
    minRows,
    removeHandle = false,
    minimal = true,
    size = 'md',
    withCount,
    ...rest
  } = props;

  return (
    <>
      <TextareaAutosize
        ref={inputRef as any}
        data-testid={testId}
        className={className}
        placeholder={placeholder}
        minRows={minRows || 1}
        role="textbox"
        css={[
          inputRootStyle({}),
          minimal &&
            tw`bg-transparent bg-opacity-0 border-opacity-0 hover:border-opacity-100`,
          tw`w-full px-1 py-0.5`,
          textSize[size],
          removeHandle &&
            css`
              resize: none;
            `,
        ]}
        aria-label={props['aria-label']}
        {...rest}
      />
      {withCount && props.maxLength && (
        <div tw="text-neutral-quiet text-xs text-right">
          {props.value.length} / {props.maxLength}
        </div>
      )}
    </>
  );
}
